import { render, staticRenderFns } from "./PackageFilterForm.vue?vue&type=template&id=2f5440fb&scoped=true&"
import script from "./PackageFilterForm.vue?vue&type=script&lang=js&"
export * from "./PackageFilterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5440fb",
  null
  
)

export default component.exports